import { ApolloClient } from 'apollo-client';
import { ApolloProvider } from 'react-apollo';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { ApolloLink } from 'apollo-link';
import { HttpLink } from 'apollo-link-http';
import { AuthLink, AuthOptions } from 'aws-appsync-auth-link';
import { createSubscriptionHandshakeLink } from 'aws-appsync-subscription-link';
import getConfig, { Env } from './config';
const config = getConfig(process.env.REACT_APP_ENV as Env);

const url = config.aws_appsync_graphqlEndpoint;
const region = config.aws_appsync_region;

const auth = {
  type: "API_KEY",
  apiKey: config.aws_appsync_authenticationKey
} as AuthOptions;

const appSyncLinkConfig = { url, region, auth };

export const devClient = new ApolloClient({
  cache: new InMemoryCache(),
  link: ApolloLink.from([
    new AuthLink(appSyncLinkConfig),
    createSubscriptionHandshakeLink(
      appSyncLinkConfig,
      new HttpLink({ uri: url })
    )
  ])
});

